import { getJavaRequest } from "@tipico/java-streams";
import i18n from "i18next";
import XHR from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

export const INIT_LANGUAGE_STREAM = "InitialLanguage";
export const DEFAULT_LANGUAGE = "en";

export interface InitLanguage {
    readonly language: string;
    readonly semiSelfService: boolean;
}

function createTranslationService() {
    type Mode = "standard" | "sss";
    let mode: Mode = "sss";
    const backend = new XHR(null, {
        ajax: (url, _, callback) => {
            import(`../../res/translations/${url}.json`)
                .then((translations: any) => {
                    callback(translations, { status: 200 } as any);
                })
                .catch(() => {
                    callback("{}", { status: 200 } as any);
                });
        },
        loadPath: () => {
            switch (mode) {
                case "sss":
                    return "translationsForSSS/{{lng}}/{{lng}}-{{ns}}";
                default:
                    return "{{lng}}/{{lng}}-{{ns}}";
            }
        },
        parse: data => data
    });
    return {
        backend,
        setMode: (newMode: Mode) => (mode = newMode)
    };
}
export function createI18nextContext() {
    const xhr = createTranslationService();
    i18n.use(xhr.backend)
        .use(initReactI18next)
        .init({
            debug: false,
            fallbackLng: DEFAULT_LANGUAGE,
            react: {
                wait: false
            }
        });
    getJavaRequest<InitLanguage>(INIT_LANGUAGE_STREAM).subscribe(init => {
        // tslint:disable-next-line:no-console
        console.log("Lang subscription:", JSON.stringify(init));

        xhr.setMode(init.semiSelfService ? "sss" : "standard");
        i18n.changeLanguage(init.language);
        i18n.reloadResources();
    });
    return i18n;
}
